<bar-diagram [data]="data" (click)="onInteractionClicked($event)"></bar-diagram>
<div class="right-pane" (click)="onInteractionClicked($event)">
    <div class="panel-label">{{title}}</div>
</div>
